import React from 'react';
import { StoneXTabProps } from './StoneXTab';
import './Tabs.css';

interface StoneXTabsProps {
  activeTabIndex?: number | undefined;
  // onTabChange: (index: number) => void;
  // onTabClick?: (index: number) => void;
  children: React.ReactElement<StoneXTabProps>[];
  showAddTabButton?: boolean;
  onAddTab?: (div: React.RefObject<HTMLDivElement>) => void;
  orientation?: 'horizontal' | 'vertical';
}

export default function StoneXTabs(props: StoneXTabsProps) {
  
  const { activeTabIndex, children, orientation = 'horizontal' } = props;
  // const { activeTabIndex, children, onTabChange, onTabClick } = props;

  return (
    <div className={`tabs-container ${orientation === 'vertical' ? 'vertical' : ''}`.trim()} data-active-tab-index={activeTabIndex}>
      {children}
      <div className="tab-filler" aria-hidden="true" />
    </div>
  );
}